import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";

export const QuestionList = ({ items, idPrefix = "faq", className = "" }) => (
  <Accordion type="single" collapsible className={`border-t hairline ${className}`} data-testid={`${idPrefix}-accordion`}>
    {items.map((item, i) => (
      <AccordionItem
        key={item.id ?? i}
        value={`item-${item.id ?? i}`}
        data-testid={`${idPrefix}-accordion-item-${item.id ?? i + 1}`}
        className="hairline"
      >
        <AccordionTrigger
          data-testid={`${idPrefix}-accordion-trigger-${item.id ?? i + 1}`}
          className="gap-6 py-6 font-serif text-xl text-ink hover:no-underline sm:text-2xl [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-terracotta"
        >
          <span className="flex items-baseline gap-5">
            <span className="hidden font-mono text-[10px] tracking-[0.22em] text-ink-muted sm:inline">
              {String(i + 1).padStart(2, "0")}
            </span>
            {item.q}
          </span>
        </AccordionTrigger>
        <AccordionContent className="pb-8 sm:pl-14">
          <p className="max-w-2xl text-base leading-relaxed text-ink-soft">{item.a}</p>
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
